module.exports = __webpack_public_path__ + "static/robot-fc9971de849e7c06d97fca29088f3afa.png";